import { connect } from 'react-redux';
import ConversationCreatorComponent from '../components/conversation_creator';
import ConversationCreatorActions from '../actions/conversation_creator';

function mapStateToProps(state) {
  return {
    disabled: state.conversationCreator.disabled,
    visible: state.conversationCreator.visible,
    hasState: state.conversationCreator.hasState,
    participants: state.conversationCreator.initialParticipants
  };
}

const ConversationCreatorContainer = connect(
  mapStateToProps,
  {
    createConversation: ConversationCreatorActions.createConversation,
    closeConversationCreator: ConversationCreatorActions.close,
    updateHasState: ConversationCreatorActions.updateHasState
  }
)(ConversationCreatorComponent);

export default ConversationCreatorContainer;
